import React from 'react';
import { Spin } from 'antd';

import SectionTitle from '../../../components/shared/SectionTitle';
import BookCard from '../../../components/shared/BookCard';
import { useApi } from '../../../hooks/useApi';

import { Section, ScrollRow, BookCardWrapper } from '../styles';

export default function PopularBooks() {
  const { data: books, loading } = useApi('/books/featured?count=10');

  return (
    <Section>
      <SectionTitle
        title="Los 10 Mas Populares Esta Semana"
        actionText="Ver todos"
        actionLink="/buscar"
      />
      {loading ? (
        <Spin size="large" style={{ display: 'block', margin: '40px auto' }} />
      ) : (
        <ScrollRow>
          {(books || []).map((book) => (
            <BookCardWrapper key={book.id}>
              <BookCard
                id={book.id}
                title={book.title}
                author={book.authorName}
                price={book.price}
                originalPrice={book.originalPrice}
                condition={book.condition}
                coverImage={book.coverImage}
              />
            </BookCardWrapper>
          ))}
        </ScrollRow>
      )}
    </Section>
  );
}
